import { getPOS } from 'Redux/modules/webChat/actions';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

const useGetPOS = () => {
  const { data: pos, status } = useSelector(state => state.webChat.pos, shallowEqual);

  const dispatch = useDispatch();
  const loading = status.details === 0;
  const getPOSDetails = useCallback(
    id => {
      dispatch(getPOS(id));
    },
    [dispatch],
  );

  return {
    pos,
    loading,
    getPOSDetails,
  };
};

export default useGetPOS;
